<template>
  <div v-if="modalState === 'route'" class="eventmap-page__route">
    <CloseButton
      buttonClass="eventmap-page__search-close"
      style="position: absolute; top: 1rem; right: 1rem"
      @click="closeRoute"
    />
    <div class="eventmap-page__route-destination">
      <i class="far fa-location-dot"></i>
      {{ routeEnd?.name || 'Unknown' }} {{ routeEnd?.number || '' }}
    </div>
    <div>
      <div class="eventmap-page__route-label">
        <i class="far fa-timer"></i> {{__('eventmap.route_time')}}
      </div>
      <div class="eventmap-page__route-value">
        {{ routeJourneyTime
          ? `~ ${__('eventmap.route_journey_time', { routeJourneyTime })}`
          : 'N/A' }}
      </div>
    </div>
    <div style="text-align: center;">
      <div class="eventmap-page__route-label">
        <i class="far fa-walking"></i> {{__('eventmap.route_distance')}}
      </div>
      <div class="eventmap-page__route-value">
        {{ routeDistanceFormatted || 'N/A' }}
      </div>
    </div>
    <div style="text-align: right;">
      <div class="eventmap-page__route-label">
        <i class="far fa-clock"></i> {{__('eventmap.route_eta')}}
      </div>
      <div class="eventmap-page__route-value">
        {{ routeEta || 'N/A' }}
      </div>
    </div>
    <div v-if="routeSvg" class="eventmap-page__route-svg">
      <p>{{ __('eventmap.route_scan_code_on_mobile_device_to_navigate') }}</p>
      <div class="eventmap-page__route-svg-content" v-html="routeSvg"></div>
    </div>
  </div>
</template>

<script setup>
import { defineModel, watch, ref } from 'vue';
import axios from 'axios';
import useEventMapPathFinding from '~/Components/Frontend/Eventmap/Composables/useEventMapPathFinding';

const props = defineProps({
  generateQrCodeUrl: String,
  mode: {
    type: String,
    default: 'platform',
  },
});

const emit = defineEmits(['onLocationSelected']);

const modalState = defineModel('modalState', { type: String, default: 'normal' });
const routeStart = defineModel('routeStart', { type: Object, default: null });
const routeEnd = defineModel('routeEnd', { type: Object, default: null });
const selectedLocation = defineModel('selectedLocation', { type: Object, default: null });
const activePath = defineModel('activePath', { type: Object, default: null });
const eventmapSVG = defineModel('eventmapSVG', { type: Object, default: null });
const eventmap = defineModel('eventmap', { type: Object, default: () => ({}) });
const searchText = defineModel('searchText', { type: String, default: '' });

const {
  routeDistanceFormatted, routeJourneyTime, plotRoute, routeEta, paths,
} = useEventMapPathFinding(
  eventmap,
  eventmapSVG,
  routeStart,
  routeEnd,
);

const routeSvg = ref(null);

const generateQrCode = async () => {
  if (!props.generateQrCodeUrl || !routeStart?.value?.id || !routeEnd?.value?.id || modalState.value !== 'navigate') return;

  try {
    const qrCodeUrl = props.generateQrCodeUrl
      .replace('**navigate_to**', routeEnd.value.id);

    const response = await axios.post(qrCodeUrl);
    routeSvg.value = response.data?.svg || null;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error generating QR code:', error.message);
  }
};

watch([routeStart, routeEnd], () => {
  if (routeStart?.value && routeEnd?.value) {
    plotRoute();
    generateQrCode();
  }
});

watch(paths, (newPaths) => {
  activePath.value = newPaths?.length ? newPaths : null;
});

const closeRoute = () => {
  searchText.value = '';
  activePath.value = null;
  routeEnd.value = null;
  if (props.mode === 'kiosk' && selectedLocation.value) {
    emit('onLocationSelected', selectedLocation.value);
  } else {
    selectedLocation.value = null;
    routeStart.value = null;
    modalState.value = 'normal';
    eventmapSVG.value?.resetViewBox();
  }
};
</script>
